import { ModalService } from '../../../../services/modal/modal.service';
import { ModalType } from '../../../../../js/interfaces/CoverpathTypes';
import { Router } from '@angular/router';

export const ApplicationPreviouslySentModalConfig = {
  type: ModalType.applicationPreviouslySent,
  title: 'Application Previously Sent',
  body: `<p class="modal__text">Once you send an application you cannot send links or quotes to that client.</p>
        <p class="modal__text">Your client can still modify their application before submitting it. Please contact the client to recommend any changes.</p>
        <p class="modal__text">You can view the status of the application you sent in the account center; to send another link you must change the client who will receive it.</p>`,
  actions: {
    confirm: {
      text: 'Change Client',
      callback: (modalService: ModalService) => {
        modalService.deactivate();
      },
    },
  },
};

export const ApplicationAlreadyEsignedByAdvisorModalConfig = {
  type: ModalType.applicationAlreadyEsignedByAdvisor,
  title: 'You have eSigned this Application',
  body: `<p class="modal__text">It looks like you previously eSigned this document. This can happen if you completed signing and then clicked on the same eSign button again in the email. </p>
        <p class="modal__text">You don’t need to do anything else for this application at this time. Carry on!</p>`,
  actions: {
    confirm: {
      text: 'Exit',
      callback: (modalService: ModalService) => {
        modalService.deactivate();
      },
    },
  },
};

export const ApplicationAlreadyCanceledByClientWhenAdvisorEsignModalConfig = {
  type: ModalType.applicationAlreadyCanceledByClientWhenAdvisorEsign,
  title: 'This Application has been Canceled',
  body: `<p class="modal__text">It looks like this application was canceled after we sent you an email notification to eSign. </p>
        <p class="modal__text">If you think this is an error, please contact your client; otherwise no action is required at this time. </p>`,
  actions: {
    confirm: {
      text: 'Exit',
      callback: (modalService: ModalService) => {
        modalService.deactivate();
      },
    },
  },
};

export const AdvisorSubmitSuccessConfig = {
  type: ModalType.agentSubmission,
  title: 'Your started application is ready.',
  body: `<p class="modal__text">Finish sending this application from your email.</p>`,
  actions: {
    confirm: {
      text: 'Send Another',
      callback: (modalService: ModalService, router: Router) => {
        modalService.deactivate();
        router.navigate(['/']);
      },
    },
    cancel: {
      text: 'Exit',
      callback: (modalService: ModalService, router: Router) => {
        modalService.deactivate();
        router.navigate(['/account-center']);
      },
    },
  },
};

export const AdvisorSubmitFailedConfig = {
  type: ModalType.agentSubmissionFailed,
  title: 'Something went wrong.',
  body: `<p class="modal__text">We couldn't send your application.</p>`,
  actions: {
    confirm: {
      text: 'Exit',
      callback: (modalService: ModalService) => {
        modalService.deactivate();
      },
    },
  },
};

export const StartApplicationNotCompletedConfig = {
  type: ModalType.completeApplicationForm,
  title: 'Something went wrong',
  body: `<p class="modal__text">Please fill out the form before starting an application.</p>`,
  actions: {
    confirm: {
      text: 'Go back',
      callback: (modalService: ModalService) => {
        modalService.deactivate();
      },
    },
  },
};

export const AdvisorProcessingApplication = {
  type: ModalType.advisorProcessingApplicationForm,
  title: 'Getting ready to send',
  body: `
    <div class="modal__loading-container">
      <div class="spinner spinner--small">
        <div class="spinner__dot spinner__dot--1"></div>
        <div class="spinner__dot spinner__dot--2"></div>
        <div class="spinner__dot spinner__dot--3"></div>
        <div class="spinner__dot spinner__dot--4"></div>
        <div class="spinner__dot spinner__dot--5"></div>
      </div>
    </div>
    <p class="modal__text">Your client's application is being processed and will be ready shortly.</p>
  `,
};

export const PolicyDocRetrievalFailed = {
  type: ModalType.policyDocRetrievalFailed,
  title: 'Failed to retrieve the policy packet',
  body: `<p class="modal__text">Please try again later.</p>`,
  actions: {
    confirm: {
      text: 'Close',
      callback: (modalService: ModalService) => {
        modalService.deactivate();
      },
    },
  },
};

export const ReplacementThankYouModalConfig = {
  type: ModalType.policyReplacementThankYou,
  title: '',
  body: `<p class="modal__text">Thank you for your responses.</p>`,
  actions: {
    confirm: {
      text: 'Continue',
      callback: (modalService: ModalService) => {
        modalService.deactivate();
      },
    },
  },
};

export function getStateChangeConfirmationModalConfig(yesCallback, noCallback) {
  return {
    type: ModalType.generic,
    title: 'Hold up...',
    notShowClose: true,
    disableEscapeKeyPress: true,
    body: `<p class="modal__text">You entered a zip code that will require that all of your application questions
                be answered again. Are you sure the zip code you just entered is correct?
            <br /> <br /> Note that premiums may vary by state.</p>`,
    actions: {
      confirm: {
        text: 'Yes',
        callback: yesCallback,
      },
      cancel: {
        text: 'No',
        callback: noCallback,
      },
    },
  };
}

export let GenericError = {
  type: ModalType.generic,
  title: 'Oops! Something went wrong.',
  body: `<p class="modal__text">There has been an error. Please contact your rep.</p>`,
  actions: {
    confirm: {
      text: 'Exit',
      callback: (modalService: ModalService) => {
        modalService.deactivate();
      },
    },
  },
};

export function getOtherCompanyReplacementWarning(yesCallback, noCallback) {
  return {
    type: ModalType.otherCompanyReplacementWarning,
    title: '“Other” Insurance Company Cannot Include Northwestern and MassMutual Policies',
    body: `<p class="modal__text">Using “Other” to add an existing carrier on a replacement cannot be used to specify a Northwestern Mutual or MassMutual policy. If your policy is from one of these two companies, please click “Go Back“ and choose the company from the drop-down list. Mislabelling the existing carrier will require the application process to start again.</p>`,
    actions: {
      confirm: {
        text: 'Continue',
        callback: yesCallback,
      },
      cancel: {
        text: 'Go Back',
        callback: noCallback,
      },
    },
  };
}
